import React from 'react';
import { Button, Nav, NavItem, NavLink } from 'reactstrap';
import menus from '../../../configs/menu';
import './sidebar.scss';
import { NavLink as RRNavLink } from 'react-router-dom';

const SideBarNavItem = ({ menu, onClick }) => (
  <div className='side-bar-nav-item'>
    <NavLink
      tag={menu.target ? 'a' : RRNavLink}
      exact
      to={menu.to}
      href={menu.to}
      target={menu.target}
      onClick={(e) => onClick()}
      activeClassName='sidebar-tab-active'
      className='sidebar-nav-link'
    >
      <div className='label'>{menu.label}</div>

      <div className='glyph'>
        <div className={`glyph-icon simple-icon-arrow-right`} />
      </div>
    </NavLink>
  </div>
);

export const Sidebar = ({ isMobileView, onClick }) => {
  return (
    <div
      style={{
        position: isMobileView ? 'fixed' : undefined,
        zIndex: isMobileView ? 15 : undefined,
      }}
      className={isMobileView ? 'sidebar-mobile-wrapper' : 'sidebar-wrapper'}
    >
      <div className='sidebar-header'>
        <h3 style={{ fontFamily: 'Brown' }}>My Account</h3>
      </div>

      <div className='sidebar-menus'>
        <Nav className='m-auto' vertical>
          {menus.map((menu, index) => (
            <NavItem key={`menu_${index}`}>
              <SideBarNavItem
                menu={menu}
                onClick={() => {
                  if (onClick) {
                    onClick();
                  }
                  localStorage.setItem('modalOpen', JSON.stringify(false));
                }}
              />
            </NavItem>
          ))}
        </Nav>
      </div>

      <div className='other-actions-wrapper'>
        <Button outline color='primary' style={{ fontFamily: 'Brown' }}>
          Log Out
        </Button>
      </div>
    </div>
  );
};
